import React, { forwardRef, useCallback } from "react";
const WizardStep = forwardRef(({ component: Component, onSubmit, ...rest }, ref) => {
  const submit = useCallback(
    (settings) => {
      if (onSubmit) {
        onSubmit(settings);
      }
    },
    [onSubmit]
  );
  return /* @__PURE__ */ React.createElement(Component, { onSubmit: submit, ref, ...rest });
});
WizardStep.displayName = "WizardStep";
export default WizardStep;
